import { render, staticRenderFns } from "./pos-product-session-list.vue?vue&type=template&id=289a8b37&"
import script from "./pos-product-session-list.vue?vue&type=script&lang=ts&"
export * from "./pos-product-session-list.vue?vue&type=script&lang=ts&"
import style0 from "./pos-product-session-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports